import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/term-condition.webp";

export default function ThreeCXPage() {
	return (
		<>
			<Breadcrumbs
				title="Term and Conditions"
				breadcrumbText="Term and Conditions"
				backgroundImage={BreadcrumbsImage}
				// titleClassName="text-5xl md:text-6xl font-bold mb-4"
			/>
			{/* Rest of your page */}
		</>
	);
}